;(function (angular, moment, _) {
  'use strict'

  angular
    .module('kilo.common.directives')
    .directive('columnSidebar', columnSidebarDirective)

  ColumnSidebarController.$inject = ['ColumnService', 'PreferencesService']

  function ColumnSidebarController (ColumnService, PreferencesService) {
    var self = this
    self.$onInit = () => {
      _.extend(self, {
        ColumnService: ColumnService,
        update: update
      })

      init()
    }

    function init () {
      PreferencesService.getPrefsFor('general').then(function (prefs) {
        self.prefs = prefs
      })
    }

    function update (col) {
      self.change({ item: col })
    }
  }

  columnSidebarDirective.$inject = []

  function columnSidebarDirective () {
    return {
      restrict: 'E',
      scope: true,
      templateUrl: '/app/common/directives/column-sidebar/column-selection-sidebar.html',
      controller: ColumnSidebarController,
      controllerAs: 'ctrl',
      bindToController: {
        columns: '=',
        visible: '=',
        type: '@',
        change: '&',
        reset: '&'
      }
    }
  }
})(window.angular, window.moment, window._)
